import React, { useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { format, parseISO } from 'date-fns'

// Local imports
import LoadingRequest from 'pages/approval-center/components/LoadingRequest'
import DetailsText from 'pages/approval-center/components/DetailsText'
import BodyText from 'pages/approval-center/components/BodyText'
import AdxFileAttachmentLeave from 'components/reusable/fileAttachment/AdxFileAttachmentLeave'
import CreditApproval from 'module/leave/pages/leaveCreditDetails/components/creditApproval'
import { authContext } from 'contexts/AuthContext'

// API services
import { useShowLeaveRequest } from 'services/api/modules/leave/leaveRequest'
import { usePutLeaveApproval } from 'services/api/modules/leave/leaveApproval'

const LeaveCreditRequest = ({ id, setReject, setApprove, setMutation, requestId }) => {
  const { data: userData } = useContext(authContext).auth
  const navigate = useNavigate()

  // CALL API HERE
  const { data: requestItem, isLoading } = useShowLeaveRequest(requestId)
  const mutation = usePutLeaveApproval()

  // function for parent's reject button
  useEffect(() => {
    setReject(() => () => {
      mutation.mutate(
        {
          id,
          postData: {
            staff_id: userData.staff.id,
            status: 0,
          },
          requestId,
        },
        {
          onSuccess: () => navigate(-1),
        }
      )
    })
    setApprove(() => () => {
      mutation.mutate(
        {
          id,
          postData: {
            staff_id: userData.staff.id,
            status: 1,
          },
          requestId,
        },
        {
          onSuccess: () => navigate(-1),
        }
      )
    })
    setMutation(mutation)
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setMutation(mutation)
  }, [mutation.isLoading]) // eslint-disable-line react-hooks/exhaustive-deps
  return isLoading ? (
    <LoadingRequest />
  ) : (
    <Box>
      <DetailsText title="Type" text={requestItem?.leave_policy_name} />
      <DetailsText title="Shift" text={requestItem?.type} />
      <Box display="flex" alignItems="center">
        <DetailsText
          title="Date"
          text={
            <>
              <Typography as="span">
                {requestItem?.start_date &&
                  `${format(parseISO(requestItem?.start_date), `eee, dd/MM/yyyy`)} - ${format(
                    parseISO(requestItem?.end_date),
                    `eee, dd/MM/yyyy`
                  )}`}
              </Typography>
              <Typography as="span" variant="body1" color="alternate.main" ml={2}>
                ({requestItem?.duration} {requestItem?.duration === 1 ? 'day' : 'days'})
              </Typography>
            </>
          }
        />
      </Box>
      <DetailsText title="Requester" text={requestItem?.staff_name} />
      <BodyText title="Leave purpose" text={requestItem?.reason ? requestItem?.reason : 'N/A'} />
      {requestItem?.attachment && (
        <BodyText title="Supporting document">
          <AdxFileAttachmentLeave
            item={{
              name: requestItem?.attachment,
              url: requestItem?.attachment_url,
            }}
          />
        </BodyText>
      )}

      <CreditApproval approvalArr={requestItem?.leave_approval} requestItem={requestItem} />
    </Box>
  )
}

export default LeaveCreditRequest
